import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPhoto = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M5.333 2.667a2.667 2.667 0 0 0-2.666 2.666v7.448l3.057-3.057.018-.018c.803-.773 1.81-1.266 2.925-1.266 1.114 0 2.121.493 2.924 1.266l.019.018 3.057 3.057.39-.39.018-.018c.804-.773 1.81-1.266 2.925-1.266 1.114 0 2.121.493 2.924 1.266l.019.018.39.39V5.333a2.667 2.667 0 0 0-2.666-2.666H5.333Zm16 13.885-2.266-2.266c-.41-.39-.78-.512-1.067-.512-.288 0-.657.121-1.067.512l-.38.38 1.723 1.724a1.333 1.333 0 0 1-1.886 1.886l-2.666-2.666-3.99-3.99c-.41-.392-.78-.513-1.067-.513-.288 0-.658.121-1.067.512l-4.933 4.933v2.115a2.667 2.667 0 0 0 2.666 2.666h13.334a2.667 2.667 0 0 0 2.666-2.666v-2.115ZM0 18.667A5.333 5.333 0 0 0 5.333 24h13.334A5.333 5.333 0 0 0 24 18.667V5.333A5.333 5.333 0 0 0 18.667 0H5.333A5.333 5.333 0 0 0 0 5.333v13.334Zm14.667-12c0-.737.597-1.334 1.333-1.334h.013a1.333 1.333 0 1 1 0 2.667H16a1.333 1.333 0 0 1-1.333-1.333Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPhoto);
export default ForwardRef;
